module.exports = __webpack_public_path__ + "img/IT0000441161686.d723fab0.svg";